import { useState, useEffect } from 'react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
    }`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <div className="flex items-center gap-2">
            <i className={`ri-plane-line text-2xl ${isScrolled ? 'text-teal-600' : 'text-white'}`}></i>
            <span className={`text-xl font-bold ${isScrolled ? 'text-gray-900' : 'text-white'}`} style={{ fontFamily: 'Poppins, sans-serif' }}>
              USA Travel Guide
            </span>
          </div>
          
          <div className="hidden md:flex items-center gap-8">
            <a href="/" className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
              isScrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white hover:text-teal-200'
            }`}>
              Trang chủ
            </a>
            <a href="#" className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
              isScrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white hover:text-teal-200'
            }`}>
              Tour du lịch
            </a>
            <a href="#" className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
              isScrolled ? 'text-teal-600' : 'text-white'
            }`}>
              Visa & Tips
            </a>
            <a href="#" className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
              isScrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white hover:text-teal-200'
            }`}>
              Liên hệ
            </a>
          </div>

          <button className="md:hidden w-10 h-10 flex items-center justify-center">
            <i className={`ri-menu-line text-2xl ${isScrolled ? 'text-gray-900' : 'text-white'}`}></i>
          </button>
        </div>
      </div>
    </nav>
  );
}